<template>
  <v-img
    v-if="namespace === 'Inicio'"
    :height="$vuetify.breakpoint.xsOnly ? '100vh' : '30vh'"
    gradient="to top, rgba(255, 255, 255, .2), rgba(255, 255, 255, .2)"
    :src="image"
    color="grey lighten-3"
  >
    <v-container fill-height>
      <v-row
        align="center"
        align-content="center"
        justify="center"
        class="fill-height"
      >
        <v-col cols="1">
          <v-btn
            class="ma-2"
            text
            icon
            color="accent"
            :to="leftRoute"
          >
            <v-icon size="50">
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="10">
          <h1
            class="display-2 text-center"
            v-text="title"
          />
        </v-col>
        <v-col cols="1">
          <v-btn
            class="ma-2"
            text
            icon
            color="accent"
            :to="rightRoute"
          >
            <v-icon size="50">
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-img>

  <v-img
    v-else
    :height="$vuetify.breakpoint.xsOnly ? '100vh' : '30vh'"
    gradient="to top, rgba(255, 255, 255, .2), rgba(255, 255, 255, .2)"
    :src="image"
    color="grey lighten-3"
  >
    <v-container fill-height>
      <v-row
        align="center"
        align-content="center"
        justify="center"
        class="fill-height"
      >
        <v-col
          cols="1"
          class="pr-0"
        >
          <v-btn
            class="ma-2"
            text
            icon
            color="accent"
            :to="leftRoute"
          >
            <v-icon size="50">
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          cols="10"
        >
          <h1
            class="display-2 text-center"
            v-text="title"
          />
        </v-col>
        <v-col
          cols="1"
        >
          <v-btn
            class="ma-2"
            text
            icon
            color="accent"
            :to="rightRoute"
          >
            <v-icon size="50">
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
        <v-breadcrumbs
          :items="breadcrumbs"
          class="grey--text pb-0 px-3 pt-0"
        />
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
  export default {
    computed: {
      breadcrumbs () {
        const home = { text: 'Inicio', to: '/' }
        if (!this.$store.state.langSwitch) {
          home.text = 'Inicio'
        } else {
          home.text = 'Home'
        }

        switch (this.namespace) {
          case 'Nuestros Servicios':
            if (!this.$store.state.langSwitch) {
              return [home, { text: 'Nuestros Servicios' }]
            } else {
              return [home, { text: 'Our Services' }]
            }
          case 'Nuestro Equipo':
            if (!this.$store.state.langSwitch) {
              return [home, { text: 'Nuestro Equipo' }]
            } else {
              return [home, { text: 'Our Team' }]
            }
          case 'Contacto':
            if (!this.$store.state.langSwitch) {
              return [home, { text: 'Contacto' }]
            } else {
              return [home, { text: 'Contact Us' }]
            }
          case 'Actualidad Legal':
            if (!this.$store.state.langSwitch) {
              return [home, { text: 'Actualidad Legal' }]
            } else {
              return [home, { text: 'Legal News' }]
            }
          default: return []
        }
      },
      namespace () {
        return this.$route.name
      },
      title () {
        switch (this.namespace) {
          case 'Nuestros Servicios':
            if (!this.$store.state.langSwitch) {
              return 'Nuestros Servicios'
            } else {
              return 'Our Services'
            }
          case 'Nuestro Equipo':
            if (!this.$store.state.langSwitch) {
              return 'Nuestro Equipo'
            } else {
              return 'Our Team'
            }
          case 'Contacto':
            if (!this.$store.state.langSwitch) {
              return 'Contacto'
            } else {
              return 'Contact Us'
            }
          case 'Actualidad Legal':
            if (!this.$store.state.langSwitch) {
              return 'Actualidad Legal'
            } else {
              return 'Legal News'
            }
          default: return ''
        }
      },
      image () {
        switch (this.namespace) {
          case 'Inicio': return '/static/charlie-solorzano-aeXK1IeVVoI-unsplash.jpg'
          case 'Nuestros Servicios': return '/static/andrew-neel-cckf4TsHAuw-unsplash.jpg'
          case 'Nuestro Equipo': return '/static/jeremy-beadle-qnU-UR0o5X8-unsplash.jpg'
          case 'Contacto': return '/static/bill-oxford-OXGhu60NwxU-unsplash.jpg'
          case 'Actualidad Legal': return '/static/o12-nAjil1z3eLk-unsplash.jpg'
          default: return ''
        }
      },
      leftRoute () {
        switch (this.namespace) {
          case 'Inicio': return '/contacto'
          case 'Nuestros Servicios': return '/'
          case 'Nuestro Equipo': return '/nuestros-servicios'
          case 'Contacto': return '/nuestro-equipo'
          default: return ''
        }
      },
      rightRoute () {
        switch (this.namespace) {
          case 'Inicio': return '/nuestros-servicios'
          case 'Nuestros Servicios': return '/nuestro-equipo'
          case 'Nuestro Equipo': return '/contacto'
          case 'Contacto': return '/'
          default: return ''
        }
      }
    }
  }
</script>
